import React, { Component } from "react";
import { Tab, Tabs, Button } from "react-bootstrap";
import Codes from "./Codes";
import RevenueNonRevenue from "./RevenueNonRevenue";
import Payment from "./Payment";
import Segmentation from "./Segmentation";
import DepositAudit from "./DepositAudit";
import TaxAudit from "./TaxAudit/TaxAudit";
import Statistics from "./Statistics";
import FilesSection from "./FilesSection";
import { LedgersSection } from "./LedgersSection";
import { DailyActivityService } from "../../../../Common/Services/DailyActivity";
import { confirmAlert } from "react-confirm-alert";

class EntryTabs extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      activeTab: "statistics",
      tabData: this.defaultValues(),
      isTabValuesModified: false,
      isActionPending: false,
    };
  }

  componentDidMount() {
    this.getDailyTransactions();
  }
  componentDidUpdate(prevProps) {
    if (
      !this.props.isLoadingDefaultDate &&
      (prevProps.selectedDate !== this.props.selectedDate ||
        prevProps.filterHotelId !== this.props.filterHotelId)
    ) {
      if (this.props.selectedDate) {
        this.getDailyTransactions();
      } else {
        this.setState({ tabData: this.defaultValues() });
      }
    }
  }

  defaultValues = () => {
    return {
      revenue: "0.00",
      nonRevenue: "0.00",
      payment: "0.00",
      segmentation: "0.00",
      depositAudit: "0.00",
      taxAudit: "0.00",
      statistics: "",
    };
  };

  getDailyTransactions = async () => {
    const { filterHotelId, selectedDate } = this.props;
    if (!filterHotelId || !selectedDate) {
      return;
    }

    this.setState({ isDataLoading: true });
    try {
      const data =
        (await DailyActivityService.getDailyTransactions(
          filterHotelId,
          selectedDate
        )) ?? [];

      const tabData = {
        revenue:
          data.find((item: any) => item.type === "Revenue")?.totalDetails ||
          "0.00",
        nonRevenue:
          data.find((item: any) => item.type === "Non Revenue")?.totalDetails ||
          "0.00",
        payment:
          data.find((item: any) => item.type === "Payment")?.totalDetails ||
          "0.00",
        segmentation:
          data.find((item: any) => item.type === "Segmentation")
            ?.totalDetails || "0.00",
        depositAudit: "0.00",
        taxAudit: "0.00",
        statistics:
          data.find((item: any) => item.type === "Statistics")?.totalPMS || "",
      };
      //this.setState({ tabData, isDataLoading: false });
    } catch (error) {
      this.setState({
        tabData: this.defaultValues(),
        isDataLoading: false,
      });
      console.error("Error fetching data:", error);
    }
  };

  handleTabSelect = (selectedTab: any) => {
    this.refreshMainData();
    this.setCurrentTabStatusOnValuesChanges(false);
    this.setState({ activeTab: selectedTab });
  };
  setCurrentTabStatusOnValuesChanges = (isTabValuesModified) => {
    this.props?.setCurrentTabStatusOnValuesChanges(isTabValuesModified);
    this.setState({ isTabValuesModified });
  };

  confirmationOnTabChange = (selectedTab: any) => {
    if (this.state.isTabValuesModified && this.state.activeTab != selectedTab) {
      confirmAlert({
        title: "Unsaved confirmation?",
        message:
          "You have unsaved changes on this tab. Do you want to leave this tab and discard your changes?",
        buttons: [
          {
            label: "Yes",
            onClick: () => this.handleTabSelect(selectedTab),
          },
          {
            label: "No",
            onClick: () => { },
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    } else {
      this.handleTabSelect(selectedTab);
    }
  };

  refreshMainData = () => {
    this.getDailyTransactions();
  };

  renderTabContent = () => {
    const { activeTab } = this.state;

    const props = {
      ...this.props,
      refreshMainData: this.refreshMainData,
      setCurrentTabStatusOnValuesChanges:
        this.setCurrentTabStatusOnValuesChanges,
    };

    switch (activeTab) {
      case "codes":
        return <Codes />;
      case "statistics":
        return <Statistics {...props} />;
      case "revenue":
        return <RevenueNonRevenue {...props} type="1" />;
      case "non-revenue":
        return <RevenueNonRevenue {...props} type="2" />;
      case "payment":
        return (
          <Payment
            {...this.props}
            refreshMainData={this.refreshMainData}
            setCurrentTabStatusOnValuesChanges={
              this.setCurrentTabStatusOnValuesChanges
            }
          />
        );
      case "segmentation":
        return (
          <Segmentation
            {...this.props}
            refreshMainData={this.refreshMainData}
            setCurrentTabStatusOnValuesChanges={
              this.setCurrentTabStatusOnValuesChanges
            }
          />
        );
      case "deposit-audit":
        return <DepositAudit {...props}
          setCurrentTabStatusOnValuesChanges={
            this.setCurrentTabStatusOnValuesChanges
          }
        />;
      case "tax-audit":
        return <TaxAudit {...props} {...this.state} />;
      default:
        return null;
    }
  };
  render() {
    const {
      tabData: {
        revenue,
        nonRevenue,
        payment,
        segmentation,
        depositAudit,
        taxAudit,
        statistics,
      },
    } = this.state;

    const USDollar = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });

    return (
      <div className="daily-activity-entry reuse-design d-flex">
        <div className="left-area">
          <Tabs
            className="tab-section"
            id="controlled-tab-example"
            activeKey={this.state.activeTab}
            onSelect={this.confirmationOnTabChange}
            mountOnEnter
            unmountOnExit
          >
            <Tab
              eventKey="codes"
              title={
                <div className="link-area">
                  <div className="d-flex justify-content-center">
                    <div>Codes</div>
                    <div className="icn">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M8 4.25C8.4125 4.25 8.75 4.5875 8.75 5V8C8.75 8.4125 8.4125 8.75 8 8.75C7.5875 8.75 7.25 8.4125 7.25 8V5C7.25 4.5875 7.5875 4.25 8 4.25ZM7.9925 0.5C3.8525 0.5 0.5 3.86 0.5 8C0.5 12.14 3.8525 15.5 7.9925 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 7.9925 0.5ZM8 14C4.685 14 2 11.315 2 8C2 4.685 4.685 2 8 2C11.315 2 14 4.685 14 8C14 11.315 11.315 14 8 14ZM8.75 11.75H7.25V10.25H8.75V11.75Z"
                          fill="#D6742C"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center count-txt">
                    4
                  </div>
                </div>
              }
            >
              {this.renderTabContent()}
            </Tab>
            <Tab
              eventKey="statistics"
              title={
                <div className="link-area">
                  <div className="d-flex justify-content-center">
                    Statistics
                  </div>
                  <div className="d-flex justify-content-center count-txt">
                    {statistics}
                  </div>
                </div>
              }
            >
              {this.renderTabContent()}
            </Tab>
            <Tab
              eventKey="revenue"
              title={
                <div className="link-area">
                  <div className="d-flex justify-content-center">Revenue</div>
                  <div className="d-flex justify-content-center count-txt">
                    {USDollar.format(revenue)}
                  </div>
                </div>
              }
            >
              {this.renderTabContent()}
            </Tab>
            <Tab
              eventKey="non-revenue"
              title={
                <div className="link-area">
                  <div className="d-flex justify-content-center">
                    Non-Revenue
                  </div>
                  <div className="d-flex justify-content-center count-txt">
                    {USDollar.format(nonRevenue)}
                  </div>
                </div>
              }
            >
              {this.renderTabContent()}
            </Tab>
            <Tab
              eventKey="payment"
              title={
                <div className="link-area">
                  <div className="d-flex justify-content-center">Payment</div>
                  <div className="d-flex justify-content-center count-txt">
                    {USDollar.format(payment)}
                  </div>
                </div>
              }
            >
              {this.renderTabContent()}
            </Tab>
            <Tab
              eventKey="segmentation"
              title={
                <div className="link-area">
                  <div className="d-flex justify-content-center">
                    Segmentation
                  </div>
                  <div className="d-flex justify-content-center count-txt">
                    {USDollar.format(segmentation)}
                  </div>
                </div>
              }
            >
              {this.renderTabContent()}
            </Tab>
            <Tab
              eventKey="deposit-audit"
              title={
                <div className="link-area">
                  <div className="d-flex justify-content-center">
                    Deposit Audit
                  </div>
                  <div className="d-flex justify-content-center count-txt">
                    {USDollar.format(depositAudit)}
                  </div>
                </div>
              }
            >
              {this.renderTabContent()}
            </Tab>
            <Tab
              eventKey="tax-audit"
              title={
                <div className="link-area">
                  <div className="d-flex justify-content-center">Tax Audit</div>
                  <div className="d-flex justify-content-center count-txt">
                    {/* {USDollar.format(taxAudit)} */}
                    {USDollar.format(revenue)}
                  </div>
                </div>
              }
            >
              {this.renderTabContent()}
            </Tab>
          </Tabs>
        </div>

        <div className="right-area">
          <div className="section">
            <Button variant="primary" className="startToEnd" disabled>
              Complete Entry
            </Button>
          </div>
          <div className="section">
            <LedgersSection />
          </div>
          <div className="section">
            <FilesSection />
          </div>
        </div>
      </div>
    );
  }
}

export default EntryTabs;
